import {Component, Inject} from '@angular/core';
import {CustomTitleComponent} from '../../../shared/components/custom-title/custom-title.component';
import {MaterialModule} from '@app/material.module';
import {CustomMessageService} from '@app/shared/components/custom-message/custom-message.service';
import {CustomSnackBarService} from '@app/shared/components/custom-snack-bar/custom-snack-bar.service';
import {FormsModule} from '@angular/forms';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { TableStructureModel } from '@app/types/custom-table.types';
import { SimpleExcelService } from '@app/services/utils/simple-excel.service';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-see-info',
    imports: [CustomTitleComponent, MaterialModule, FormsModule, CommonModule],
    templateUrl: './see-info-dialog.component.html',
    styleUrl: './see-info-dialog.component.scss',
})
export class SeeInfoDialogComponent {
    uiData: any[] = [];
    selected = 0;

    ogData: any;
    facturas: any[] = [];
    status = '';

    constructor(
        private customMessage: CustomMessageService,
        private customSnackBar: CustomSnackBarService,
        public dialogRef: MatDialogRef<SeeInfoDialogComponent>,
        private simpleExcel: SimpleExcelService,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {
        this.ogData = data.facturas;
        this.facturas = this.ogData.facturas;
        this.status = this.ogData.status;
    }

    async ngOnInit() {
        this.customMessage.open({title: 'Cargando Información de Documentos', type: 'info', message: 'Cargando', duration: 1500});

        this.customSnackBar.open('Carga correcta', 'info');
    }

    async _download() {
        const fileName = `Facturas-${this.status.replace(/ /g, '-')}-${new Date().toISOString().slice(0, 10)}`;
        let facturaStruct: TableStructureModel[] = [
            {columnKey: 'folio', columnName: 'Folio', type: 'string'},
            {columnKey: 'fechaEmision', columnName: 'Fecha de Emisión', type: 'date'},
            {columnKey: 'fechaVencimiento', columnName: 'Fecha de Vencimiento', type: 'date'},
            {columnKey: 'receptorNombre', columnName: 'Nombre Receptor', type: 'string'},
            {columnKey: 'receptorRFC', columnName: 'RFC Receptor', type: 'string'},
            {columnKey: 'status', columnName: 'Estatus', type: 'string'},
            {columnKey: 'total', columnName: 'Total', type: 'currency'},
        ];
        await this.simpleExcel.simpleXLSX({
            fileName: fileName,
            sheets: [
                {
                    sheetName: this.status,
                    columns: facturaStruct,
                    data: this.facturas,
                    header: [`Facturas con estado "${this.status}"`, `Total de facturas: ${this.facturas.length}`, 'Epione'],
                    lineBreak: 1,
                },
            ],
        });
    }

    _close() {
        this.dialogRef.close({
            data: false,
        });
    }
}
